"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBase = void 0;
var LftCardShape_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftCardShape"));
var react_1 = __importDefault(require("react"));
var card_base_styles_1 = require("./card-base.styles");
var CardBase = function (_a) {
    var cabecalho = _a.cabecalho, conteudo = _a.conteudo, rodape = _a.rodape, testid = _a.testid;
    return (react_1.default.createElement(card_base_styles_1.CardBaseStyled, { "data-testid": testid },
        react_1.default.createElement(LftCardShape_1.default, null,
            react_1.default.createElement(card_base_styles_1.CardBaseConteudoStyled, null,
                react_1.default.createElement(card_base_styles_1.CabecalhoStyled, { "data-testid": "cabecalho-card-base" }, cabecalho),
                conteudo && react_1.default.createElement(card_base_styles_1.ConteudoStyled, { "data-testid": "conteudo-card-base" }, conteudo),
                react_1.default.createElement(card_base_styles_1.RodapeStyled, { "data-testid": "rodape-card-base" }, rodape)))));
};
exports.CardBase = CardBase;
